import * as _ from 'lodash'


export const getActiveTag = (isActive) => {
  if (isActive) {
    return { color: "green", name: "Yes" }
  }
  return { color: "red", name: "No" }
}
